import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
import { TaskModel, TasksSearchResult } from 'app/models/dms/tasksSearchResult.model';
import { TaskService } from 'app/services/task.service';
import { UserService } from 'app/services/user.service';
import { Constants } from 'app/utility/constants';

@Component({
    selector: 'app-reminder-list',
    templateUrl: './reminder-list.component.html',
    styleUrls: ['./reminder-list.component.scss'],
    standalone: false
})
export class ReminderListComponent implements OnInit
{

    reminderTaskResult: TasksSearchResult;
    modal: boolean = false;
    isMobile: boolean = false;
    editActive: boolean = false;
    reminderTimes: any[] = [];
    @Output() loaded = new EventEmitter<boolean>();


    constructor(
        private taskService: TaskService,
        private platform: Platform,
        private userService: UserService,
    ) { }

    ngOnInit()
    {
        this.getReminderTimes();
        this.fetchReminderTasks();

        this.platform.ready().then(() =>
        {
            this.isMobile = (this.platform.width() < 800);
            this.platform.resize.subscribe(() =>
            {
                this.isMobile = (this.platform.width() < 800);
            });
        });

        if (this.userService.mcMinVersion("3.2.21"))
        {
            this.editActive = true;
        } else
        {
            this.editActive = false;
        }
    }

    fetchReminderTasks()
    {
        this.taskService.getReminders()
            .subscribe({
                next: async x =>
                {
                    this.reminderTaskResult = x;
                    this.loaded.emit(true);
                },
                error: async err =>
                {
                    this.userService.handleError(err);
                }
            });
    }

    handleTaskRemoved(task: TaskModel)
    {
        this.reminderTaskResult.tasks = this.reminderTaskResult.tasks.filter(t => t.id !== task.id);
        this.reminderTaskResult.resultCount--;
    }

    async getReminderTimes()
    {
        this.taskService.getCachedTaskReminderTimes()
            .subscribe({
                next: async x =>
                {
                    this.reminderTimes = x.filter(x => x.member > 0).map(v => { return { id: v.member, name: v.caption } })
                },
                error: async err =>
                {
                    this.userService.handleError(err);
                }
            });
    }

    async doRefresh(ev: any)
    {
        setTimeout(() =>
        {
            this.taskService.fetchReminders();
            ev.target.complete();

        }, 250);
    }

}
